import * as types from './types';

export const validatePasswordToken = (token: string) => ({
  type: types.VALIDATE_PASSWORD_TOKEN,
  token,
});

export const validatePasswordTokenSuccess = () => ({
  type: types.VALIDATE_PASSWORD_TOKEN_SUCCESS,
});

export const validatePasswordTokenFailure = () => ({
  type: types.VALIDATE_PASSWORD_TOKEN_FAILURE,
});

export const setPassword = (password: string, token: string) => ({
  type: types.SET_PASSWORD,
  password,
  token,
});

export const setPasswordSuccess = () => ({
  type: types.SET_PASSWORD_SUCCESS,
});

export const setPasswordFailure = () => ({
  type: types.SET_PASSWORD_FAILURE,
});
